import { render, staticRenderFns } from "./NuevaSolicitud.vue?vue&type=template&id=594b0874&"
import script from "./NuevaSolicitud.vue?vue&type=script&lang=js&"
export * from "./NuevaSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports